/** @jsx jsx */
import React from "react";
import { jsx } from "@emotion/core";
import { Formik, Field } from "formik";

import PrimaryCTAButton from "../../../../components/PrimaryCTA";
import Form from "../../../../components/Form";
import FormField from "../../../../components/FormField";
import { FormikSearchableDropdown } from "../../../../components/Input";
import Label from "../../../../components/Label";

const qualificationValidator = values => {
    let errors = {};

    if (values.qualification === "") {
        errors.qualification = "Please select a qualification type.";
    }

    return errors;
};

const SchoolLeavingQualifications = ({
    qualificationType,
    setQualificationType,
    qualificationTypeOptions,
}) => {
    return (
        <>
            <h2>What are your school leaving qualifications?</h2>
            <Formik
                initialValues={{ qualification: qualificationType }}
                validate={qualificationValidator}
                validateOnBlur={false}
                validateOnChange={true}
                onSubmit={({ qualification }) =>
                    setQualificationType(qualification)
                }
                render={({ isSubmitting, ...props}) => (
                    <Form onSubmit={props.handleSubmit}>
                        <FormField>
                            <Label htmlFor="qualification">
                                Qualification type
                            </Label>
                            <Field
                                id="qualification"
                                name="qualification"
                                data-testid="school-leaving-qualification-type"
                                options={qualificationTypeOptions}
                                component={FormikSearchableDropdown}
                            />
                        </FormField>

                        <PrimaryCTAButton 
                        data-testid="school-leaving-qualifications-next-button" 
                        type="submit"
                        disabled={isSubmitting}>
                            Next →
                        </PrimaryCTAButton>
                    </Form>
                )}
            />
        </>
    );
};

export default SchoolLeavingQualifications;
